import React, { useEffect } from "react";
import {
  IThemeConfig,
  useTheme,
  getConfig,
  PageTitle,
  PageDescription,
} from "../../../../_start/layout/core";
import { LaunchDashboardPage } from "./LaunchDashboardPage";
import { useLocation, Navigate } from "react-router";

const defaultPageConfig = getConfig();
const launchPageConfig: Partial<IThemeConfig> = {
  aside: {
    ...defaultPageConfig.aside,
    display: true,
    primaryDisplay: true,
    secondaryDisplay: false,
    toggle: true,
    content: "menu",
  },
  toolbar: {
    ...defaultPageConfig.toolbar,
    display: false,
  },
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: false,
  },
};

export function LaunchDashboardWrapper() {
  const { setTheme } = useTheme();
  const location = useLocation();
  const state = location.state as {
    projectTitle: string;
    projectID: string;
    projectDescription: string;
    userID: string;
  } | null;

  useEffect(() => {
    if (state) {
      setTheme(launchPageConfig);
      return () => {
        setTheme(defaultPageConfig);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!state) {
    return <Navigate to="/" replace />;
  }

  const { projectTitle, projectID, projectDescription, userID } = state;

  return (
    <>
      <LaunchDashboardPage
        userID={userID}
        projectID={projectID}
        projectTitle={projectTitle}
        projectDescription={projectDescription}
      />
      <PageTitle>Launch Dashboard — {projectTitle}</PageTitle>
      <PageDescription>Mission control for your product launch</PageDescription>
    </>
  );
}
